import React, { useState } from "react";

import { useTranslation } from "utils";

import { Flex, Icon, Popover, Typography } from "components";

import { DATA_STATUS } from "pages/app/all-field-view/components/FieldFilterOptions";

// same visual pattern (and class names) as the FilterChip/FilterOption used by FieldFilterOptionsChips.tsx on
// Timeline, reused here (not imported, since that file's version is tightly coupled to its own server-driven
// crop/year filtering) for a status this page instead computes locally from its own per-row completeness check
export const AllFieldsDataStatusFilter = ({
  dataStatusFilter,
  onChange,
  isDisabled = false,
}: {
  dataStatusFilter: DATA_STATUS;
  onChange: (status: DATA_STATUS) => void;
  isDisabled?: boolean;
}) => {
  const { t } = useTranslation("allFieldView");
  const [isOpen, setIsOpen] = useState(false);

  const label =
    dataStatusFilter !== DATA_STATUS.ALL
      ? t(`fieldFilterOptions.modal.sections.dataStatus.options.${dataStatusFilter}`)
      : t("fieldFilterOptions.modal.sections.dataStatus.title");

  return (
    <Flex className={`field-filter-chip ${dataStatusFilter !== DATA_STATUS.ALL ? "active" : ""} ${isDisabled ? "disabled" : ""}`}>
      <Popover
        open={isOpen}
        onOpenChange={(open) => {
          if (!isDisabled) setIsOpen(open);
        }}
        trigger="click"
        placement="bottomLeft"
        className="filter-chip-popover"
        content={
          <Flex vertical className="filter-chip-popover-content" data-testid="all-fields-data-status-checkboxes-container">
            {Object.values(DATA_STATUS).map((status) => (
              <Flex
                key={status}
                className={`filter-chip-option${dataStatusFilter === status ? " selected" : ""}`}
                justify="space-between"
                align="center"
                role="button"
                tabIndex={0}
                data-testid={`all-fields-data-status-checkbox-${status}`}
                onClick={() => {
                  onChange(status);
                  setIsOpen(false);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onChange(status);
                    setIsOpen(false);
                  }
                }}
              >
                <Typography variant="paragraph-m" className="margin-0">
                  {t(`fieldFilterOptions.modal.sections.dataStatus.options.${status}`)}
                </Typography>
                {dataStatusFilter === status && <Icon iconName="tabler/circle-check" size="m-light" className="filter-chip-option-check" />}
              </Flex>
            ))}
          </Flex>
        }
      >
        <Flex className="field-filter-chip-trigger" align="center" gap="0.5rem" role="button" tabIndex={0}>
          <Typography variant="paragraph-m" noWrap className="margin-0">
            {label}
          </Typography>
          <Icon iconName="tabler/chevron-down" size="s" />
        </Flex>
      </Popover>
    </Flex>
  );
};
